import { FilledLinkToMediaField } from '@prismicio/types';

import { Modal, ModalProps } from '../../../../../design-system/components/modal/Modal';

import style from './AgencyVideoModal.module.css';

type AgencyModalProps = ModalProps & {
    agencyName: string;
    video: FilledLinkToMediaField;
};

export function AgencyVideoModal({ isOpen, close, onClose, agencyName, video }: AgencyModalProps) {
    return (
        <Modal
            size="fullscreen"
            dark={true}
            isOpen={isOpen}
            close={close}
            onClose={onClose}
            title={agencyName}
        >
            <div className={style.container}>
                <div className={style.videoWrapper}>
                    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                    <video
                        className={style.video}
                        src={video.url}
                        preload="auto"
                        controls={true}
                        autoPlay={true}
                        playsInline={true}
                        loop={false}
                        onLoadStart={(event) => {
                            event.currentTarget.volume = 0.1;
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
}
